export const WinHighlightViewGrid = {
	size: 100,
	gap: 0,
	name: 'WinHighlightViewGrid',
	padding: {
		top: 5,
		bottom: 5,
		left: 5,
		right: 5,
		portrate: {
			top: 0,
			bottom: 0,
			left: 3,
			right: 3
		}
	},
	main: [
		{
			name: 'winhighlight',
			size: 70,
			type: 'PortrateGridController',
			config: {
				name: 'winhilight2',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 30
					},
					{
						name: 'win_highlight_holder_up',
						size: 50,
						// align: 'bottom_center',
						bounds: {
							width: 806,
							height: 707
						}
					}
				]
			}
		}
	],
	landscape: [
		{
			name: 'winhighlight-landscape',
			size: 65,
			type: 'PortrateGridController',
			config: {
				name: 'winhilight2',
				size: 100,
				gap: 0,
				main: [
					{
						name: 'empty',
						size: 30
					},
					{
						name: 'win_highlight_holder_up',
						size: 50,
						// align: 'bottom_center',
						bounds: {
							width: 806,
							height: 707
						}
					}
				]
			}
		}
	],
	portrate: [
		{
			name: 'empty',
			size: 30
		},
		{
			name: 'win_highlight_holder_up',
			size: 35,
			align: 'top',
			bounds: {
				width: 806,
				height: 707
			}
		}
	]
};
